var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import clsx from 'clsx';
import { html, LitElement } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import { BaseComponent } from '../utils/BaseComponent';
let Button = class Button extends BaseComponent {
    constructor() {
        super(...arguments);
        this.autoFocus = false;
    }
    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        if (this.autoFocus) {
            this.button.focus();
        }
    }
    render() {
        const classes = clsx(this.classNames, {
            button: true,
            // primary buttons
            'button--primary': this.primary,
            'button--destructive': this.destructive,
            // quiet
            'button--flat': this.quiet,
            'button--destructive-flat': this.destructive && this.quiet,
            'button--utility-flat': this.utility && this.quiet,
            // others
            'button--small': this.small,
            'button--utility': this.utility && this.quiet,
            'button--link': this.link,
            'button--pill': this.pill,
            'button--in-progress': this.loading,
        });
        return this.href ? html `
                <a
                href=${this.href}
                data-test=${this.dataTest}
                target=${this.target}
                rel=${this.target === '_blank' ? this.rel || 'noopener' : undefined}
                class=${classes}
                >
                    <slot>You have to put something inside the button link!</slot>
                </a>`
            : html `
                <button
                    data-test=${this.dataTest}
                    type=${this.type || 'button'}
                    class=${classes}
                    ?disabled=${this.disabled}>
                    <slot>You have to put something inside the button!</slot>
                </button>`;
    }
};
Button.shadowRootOptions = { ...LitElement.shadowRootOptions, delegatesFocus: true };
__decorate([
    property({ type: Boolean })
], Button.prototype, "autoFocus", void 0);
__decorate([
    property()
], Button.prototype, "href", void 0);
__decorate([
    property()
], Button.prototype, "target", void 0);
__decorate([
    property()
], Button.prototype, "rel", void 0);
__decorate([
    property()
], Button.prototype, "type", void 0);
__decorate([
    property({ type: Boolean })
], Button.prototype, "disabled", void 0);
__decorate([
    property({ type: Boolean })
], Button.prototype, "primary", void 0);
__decorate([
    property({ type: Boolean })
], Button.prototype, "secondary", void 0);
__decorate([
    property({ type: Boolean })
], Button.prototype, "destructive", void 0);
__decorate([
    property({ type: Boolean })
], Button.prototype, "small", void 0);
__decorate([
    property({ type: Boolean })
], Button.prototype, "quiet", void 0);
__decorate([
    property({ type: Boolean })
], Button.prototype, "utility", void 0);
__decorate([
    property({ type: Boolean })
], Button.prototype, "link", void 0);
__decorate([
    property({ type: Boolean })
], Button.prototype, "pill", void 0);
__decorate([
    property({ type: Boolean })
], Button.prototype, "loading", void 0);
__decorate([
    property()
], Button.prototype, "classNames", void 0);
__decorate([
    query('.button')
], Button.prototype, "button", void 0);
Button = __decorate([
    customElement('trust-button')
], Button);
export { Button };
//# sourceMappingURL=button.js.map